import { Component, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { HubService } from './hub.service';
import { BaseClass } from 'src/app/views/utility/baseClass';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { HubmodalComponent } from '../../directives/hubmodal/hubmodal.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.css']
})
export class HubComponent extends BaseClass implements OnInit{
  @ViewChild('dt') dt: any;
  public tableData: any[] = [];
  excel_paragraph='';
  public selectedItem: MenuItem | null = null;
  public commonScrollHeight = '';
  public searchText: string;
  public ref: DynamicDialogRef | undefined;
  public first2: number = 0;
  public rows2: number = 10;
  public totalRecords: number = 0;
  exceldownloadModal=false;
  public options = [];
  public paginatorArray = [];
  public visible: boolean = false;
  public position = 'top';
  public cols = [];
  public _selectedColumns = [];
  currentPageIndex: number = 0;
  rowsize: number = 10;
  tablecount: number = 0;
  message:GlobalMessage=new GlobalMessage();
  searchTerm: string = ''; 

  constructor(
    public router: Router,
    public dialogService: DialogService,
    public utilityservice :Utilityservice,
    private hubService: HubService,
    public override injector: Injector, // Make injector public here
    public PagehelpmodalService: PagehelpmodalService
  ) {
    super(injector);
    this.excel_paragraph=this.message.downloadexcel_text;
  }

  ngOnInit() {
    this.dynamiccols();
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getList();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'hubid', header: 'Hub ID', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'hubname', header: 'Hub', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'otherheader' },
      { field: 'createdby', header: 'Created By', type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },    
      { field: 'createdon', header: 'Created On', type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'activeflag', header: 'Status', type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ];
    this._selectedColumns = this.cols;
  }

  // getList() {
  //   this.hubService.getHubData().subscribe((data) => {
  //     this.tableData = data;
  //     this.options = this.utilityservice.getOptionDropdown(data.length);
  //     this.paginatorArray = this.options.map(e => e.value);
  //     this.totalRecords =this.tableData.length ;
  //     console.log(this.totalRecords);
      

  //   });
  // }

  
    getList() {
   
      const currentPageSize = this.rowsize;
      this.hubService.getHubData().subscribe({
        next: (data: any) => { 
          this.tableData = data;
          this.tableData = data.map(item => ({ ...item, isSelect: false }));
          this.options = this.utilityservice.getOptionDropdown(data.length);
          this.paginatorArray = this.options.map(e => e.value);
  
          if (!this.paginatorArray.includes(currentPageSize)) {
            this.paginatorArray.push(currentPageSize);
            this.paginatorArray.sort((a, b) => a - b);
          }
  
          this.rowsize = currentPageSize;
          this.totalRecords = this.tableData.length;
          this.tablecount = data.count ?? data.length;
          setTimeout(() => {
            if (this.dt) {
              this.dt.first = this.currentPageIndex;
            }
          }, 0);
        },
  
        error: (error) => { 
          const timestamp = new Date().toLocaleString();
          Swal.fire({
            title: error.error?.error || "Error!",
            text: `This error occurred at: ${timestamp}`,
            icon: "error",
          });
        }
      });
    }

 showDialog() {
        let payload={}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
      this.ref = this.dialogService.open(ExceldownloadComponent, {
        header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname:"Hub_Master_Data.xlsx",downloadapi:'common/gen/hubdataexcel',method:'get',message:this.excel_paragraph,payload:payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
      });
    }

  closedpop() {
    this.visible = false;
  }

  show(title, data) {
    let details = {};
    if (title === 'Modify Hub') {
      this.hubService.getHubById(data.hubid, Number).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(HubmodalComponent, {
          header: title,
          width: '50vw',
          height: '35%',
          data: { title: title, datas: details },
        });
        this.ref.onClose.subscribe(() => {
          this.getList();
        });
      });
    } else {
      details = {};
      this.ref = this.dialogService.open(HubmodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details },      });
      this.ref.onClose.subscribe(() => {
        this.getList();
      });
    }
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = 0;

        // Handle null values
        if (value1 == null && value2 != null) return -1;
        if (value1 != null && value2 == null) return 1;
        if (value1 == null && value2 == null) return 0;

        // Check if the field is createdon for date comparison
        if (event.field === 'createdon') {
            // Parse the date strings to Date objects
            const date1 = new Date(value1);
            const date2 = new Date(value2);
            return date1.getTime() - date2.getTime(); // Sort by timestamp
        }

        // Handle string comparisons for other fields
        if (typeof value1 === 'string' && typeof value2 === 'string') {
            return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
        }

        // Fallback to default number comparison for other types (like CIN Number)
        return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    // Reverse the data array if the order is descending
    return event.order === -1 ? event.data.reverse() : event.data;
}
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}
